exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1g_yVFb7xOJi2RktMZ_l9v{align-items:center;display:flex;margin-bottom:var(--music-spacer-mini)}._2qONIt9POwvMbGx4p33HOD{margin-inline-end:var(--music-spacer-mini)}\n", ""]);

// exports
exports.locals = {
	"container": "_1g_yVFb7xOJi2RktMZ_l9v",
	"icon": "_2qONIt9POwvMbGx4p33HOD"
};